var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { useCustomValidationField } from 'hx-util';
import { useFormContext } from 'react-hook-form';
import { StepLayout } from './step-layout.component';
import { pageImages } from '@/pages/images';
import { LogoAndHeading } from './logo-and-heading.component';
import { CircleSelect } from './circle-select.component';
import { BsCheck2, BsX } from 'react-icons/bs';
import { InformationToggle } from './information-toggle.component';
import { palette } from '@/theme/palette';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
export function ConnectHeadphones() {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    var control = useFormContext().control;
    var _a = useCustomValidationField({
        validationFieldName: 'headphones-connected-valid',
        fieldName: 'headphones-connected',
        validationFunction: function (value) { return value !== 'no'; },
    }), error = _a.error, validate = _a.validate;
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    return (_jsx(StepLayout, { image: pageImages.headphones, heading: _jsx(LogoAndHeading, { headingText: 'Are your headphones plugged in or paired?', className: "text-lg md:text-2xl", image: {
                height: 110,
                width: 118,
            } }), progress: {
            phase: 0,
            step: 4,
        }, content: _jsx(CircleSelect, { controllerProps: {
                name: 'headphones-connected',
                control: control,
                rules: {
                    required: 'Please select an option',
                    validate: validate,
                },
            }, itemStyles: {
                boxShadow: "0 0 4px 2px ".concat(palette.shadow.main),
                border: '3px solid var(--circle-select-color)',
                svg: {
                    stroke: 'var(--circle-select-color)',
                    strokeWidth: 1.5,
                    width: isMobile ? '2.5rem' : '3.75rem',
                    height: isMobile ? '2.5rem' : '3.75rem',
                },
                '&[data-state="checked"]': {
                    svg: { stroke: 'white' },
                    border: '3px solid white',
                },
                width: isMobile ? '3.75rem' : '5.625rem',
                height: isMobile ? '3.75rem' : '5.625rem',
                margin: isMobile ? '0.75rem' : '1rem',
            }, options: [
                {
                    label: 'Yes',
                    value: 'yes',
                    icon: _jsx(BsCheck2, {}),
                },
                {
                    label: 'No',
                    value: 'no',
                    icon: _jsx(BsX, {}),
                },
            ] }), info: _jsxs("div", __assign({ className: "flex flex-col items-center gap-1" }, { children: [!!error && (_jsx("span", __assign({ className: "text-red text-xs sm:text-sm text-center" }, { children: "This assessment requires you to plug in or pair your headphones." }))), _jsx(InformationToggle, __assign({ title: 'Why do I need Headphones?', chevronColor: theme.palette.primary.main, onClick: function () { return handleSendButtonClick('why_do_i_need_headphones'); } }, { children: _jsx(Typography, __assign({ className: 'text-xs md:text-base' }, { children: "This assessment aims to determine if digits can be heard within varying degrees of background noise. Headphones help ensure that you only hear the background noise of the hearing assessment." })) }))] })), nav: _jsx(NavigationButtonsContainer, { children: _jsx(NavigationButton, { type: "back", variant: "outlined", label: "Previous" }) }) }));
}
